<template>
  <div class="boss-agreement-headline-container clearfix">
    <div class="boss-agreement-headline-wrap">
      <div class="float-left boss-agreement-left">
        <div class="boss-agreement">
          掲載期間 ｜ {{ firstDate }}〜{{ lastDate }}
        </div>
      </div>
      <div
        v-if="isPublished"
        class="float-right boss-agreement-right"
      >
        <div class="boss-agreement-right-container">
          <div class="boss-agreement-right-wrap clearfix">
            <div class="float-left boss-agreement-right-item">
              <div class="boss-icon boss-icon-scout boss-scout" />
              <span data-test="scout-count">スカウト残数：{{ remainingScoutAmount.toLocaleString() }}通／{{ scoutLimit.toLocaleString() }}通</span>
              <span
                v-if="reservedScoutFirstSendAmount"
                data-test="reserved-count"
              >（予約{{ reservedScoutFirstSendAmount.toLocaleString() }}名含む）</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    firstDate: {
      type: String,
      required: true
    },
    lastDate: {
      type: String,
      required: true
    },
    scoutLimit: {
      type: Number,
      default: 0
    },
    sentScoutAmount: {
      type: Number,
      default: 0
    },
    reservedScoutFirstSendAmount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isPublished () {
      return dayjs().isBetween(dayjs(this.firstDate), dayjs(this.lastDate), 'days', '[]')
    },
    remainingScoutAmount () {
      const amount = this.scoutLimit - this.sentScoutAmount - this.reservedScoutFirstSendAmount
      return amount < 0 ? 0 : amount
    }
  }
}
</script>
